'use client'
import { usePathname } from "next/navigation"
import { Dispatch, FunctionComponent, ReactNode, SetStateAction, useEffect, useState } from "react"

/**
 * Do not show elements if iframe-compact mode is enabled.
 */
export const IFrameCompact = ({ children, setIsExpand }: {
  children: ReactNode,
  setIsExpand?:Dispatch<SetStateAction<boolean>>
}) => {
  const [hash, setHash] = useState('')
  const pathname = usePathname()

  useEffect(() => {
    if (document.readyState === "complete") {
      setHash(window.location.hash)
    } else {
      window.addEventListener('load', () => setHash(window.location.hash));
    }
  }, [pathname])
  
  useEffect(() => {
    if (typeof setIsExpand == 'function') {
      setIsExpand(hash !== '#iframe-compact');
    }
  }, [hash, setIsExpand])

  return <>{children}</>
}
